/**
 * Created by linjianxi on 2017/6/8.
 */
export const GETUSERCASHMONTH = ' GETUSERCASHMONTH '
export const CASHDETAILLIST = 'CASHDETAILLIST'
export const VIRTUALLIST = 'VIRTUALLIST'



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_detail/mutation-type.js